import _ from 'lodash'
import { removeHash } from '@wix/thunderbolt-catharsis'
import { getMultipleRefCompsIdFromInflatedId, getUniqueId } from '@wix/thunderbolt-commons'
import { createConsumptionDataNode } from './utils/dataNodeUtils'
import type { Ref } from '@wix/thunderbolt-types'
import { NthChild, ResolvedPattern } from '@wix/thunderbolt-becky-types'
import { PATTERNS_INFLATED_MAP, RESOLVED_REFS_NAMESPACE } from '../../../constants'
import { getOverrideItem } from '../../dataConsumption'
import { DataRefsForPresetResolving } from '../../types'

type PatternItem = {
	dataItemWithOverrides: Readonly<Array<ResolvedPattern | undefined>>
}
type PatternsConsumption = Ref<NthChild> | PatternItem

export const Patterns = createConsumptionDataNode<null, DataRefsForPresetResolving, PatternsConsumption>({
	updateDependencies: ({ update, inflatedComponent, dependencies }) => {
		update(
			RESOLVED_REFS_NAMESPACE,
			PATTERNS_INFLATED_MAP,
			inflatedComponent.patternsQuery,
			dependencies,
			dependencies
		)
	},
	toViewItem: ({ id, value }) => {
		if (!value) {
			return
		}

		const ancestorsChain = getMultipleRefCompsIdFromInflatedId(id)
		const { dataItemWithOverrides } = value as PatternItem
		const dataItem = getOverrideItem(dataItemWithOverrides) as ResolvedPattern
		if (!dataItem) {
			return
		}
		const itemsArr: Array<NthChild> = dataItem.items.map((item) => ({
			...item,
			variant: getUniqueId(ancestorsChain, removeHash(item.variant)),
			id: getUniqueId(ancestorsChain, removeHash(item.id)),
		}))
		const items = _.mapKeys(itemsArr, (item) => item.id)
		const itemsIds = Object.keys(items)
		return {
			[id]: {
				...dataItem,
				items: itemsIds,
				id,
			},
			...items,
		}
	},
})
